import React from 'react';
import { Building2, LayoutGrid } from 'lucide-react';
import { OfficeStats } from './OfficeStats';
import { openOffice } from '../../services/officeSelection';

export const OfficePicker = ({ data, practiceName }) => (
  <div className="min-h-screen bg-slate-50 p-4 sm:p-10" data-testid="office-picker">
    <div className="max-w-5xl mx-auto space-y-8">
      <div>
        <p className="text-sm font-semibold tracking-widest text-emerald-700 uppercase">{practiceName}</p>
        <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mt-2">Which office do you want to open?</h1>
        <p className="text-slate-600 mt-2">Each office has its own dashboard with every PractCom feature. You can switch offices any time from the top of the dashboard.</p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {data.offices.filter((o) => o.isActive !== false).map((o) => (
          <button key={o.id} onClick={() => openOffice(o.id)} data-testid={`office-picker-${o.id}`}
            className="text-left bg-white border-2 border-slate-200 hover:border-emerald-500 rounded-2xl p-5 space-y-4 transition-colors">
            <div className="flex items-center gap-2">
              <Building2 className="w-5 h-5 text-emerald-600" />
              <span className="text-xl font-bold text-slate-900">{o.name}</span>
              {o.isPrimary && <span className="text-xs bg-emerald-100 text-emerald-800 rounded-full px-2 py-0.5">Main</span>}
            </div>
            <OfficeStats stats={o.stats} testId={`office-picker-stats-${o.id}`} />
            <span className="inline-block text-sm font-semibold text-emerald-700">Open {o.name} dashboard →</span>
          </button>
        ))}
      </div>
      {data.combined && (
        <button onClick={() => openOffice('')} data-testid="office-picker-all"
          className="w-full text-left rounded-2xl bg-slate-900 p-5 space-y-3 hover:bg-slate-800 transition-colors">
          <span className="flex items-center gap-2 text-white text-lg font-bold"><LayoutGrid className="w-5 h-5" />All offices together</span>
          <OfficeStats stats={data.combined} testId="office-picker-combined" dark />
        </button>
      )}
    </div>
  </div>
);
